import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import { fireTag } from '../../libs/analytics.js';

import heroMobileImage from '../../images/articles/P00124182_WF_BRAND_1HFY24ISF_Art11_767x577.jpg';
import heroDesktopImage from '../../images/articles/P00124182_WF_BRAND_1HFY24ISF_Art11_1164x584.jpg';

import ModalOverlay from "../../components/ModalOverlay";

const Pipeline = ({
					  handleEvent,
					  closeExitOverlay,
					  addExitClickListeners,
					  modalOverlay,
				  }) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'P00124182_WF_BRAND_1HFY24ISF_Art11_ogimage.jpg';

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();


	}, []); // empty array says only use this effect once

	let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;
	// console.log(mastheadImage);
	addExitClickListeners();
	return (
		<>
			<Helmet>
				<title>Building a pipeline of sustainable affordable housing </title>
				<meta
					name="description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				<meta property="og:title" content="Building a pipeline of sustainable affordable housing"/>
				<meta
					property="og:description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Building a pipeline of sustainable affordable housing"/>
				<meta
					property="twitter:description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Building a pipeline of sustainable affordable housing
						</h1>
						<h2 className="summary">
							Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A man and woman in hardhats hold blueprints while observing a construction site."/>
					</div>
				</div>


				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By John Moon, <span>senior vice president, sustainability philanthropy leader at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>April 16, 2024</p>
							</div>
							<div>
								<p>4-minute read</p>
							</div>
						</div>
						<p>Housing affordability is an ongoing national challenge. Home construction and household energy use, such as heating, cooling, and refrigeration, can <a onClick={()=>fireTag('A1','increase')} target="_blank" href="https://ternercenter.berkeley.edu/wp-content/uploads/2024/03/Terner-Housing-Climate-March-2024.pdf" data-click-listener="true" rel="noreferrer">increase</a> greenhouse gas emissions. Additional costs to reduce these housing-related emissions by installing clean energy technologies can discourage housing and climate stakeholders. However, through thoughtful collaboration, tackling the connected issues of affordable housing and sustainability has the potential to realize affordable housing goals and lower associated emissions.
						</p>


						<p>Government sources like the Inflation Reduction Act, or the IRA, offer incentives to invest in energy efficiency measures. The <a onClick={()=>fireTag('A1','greenhouse gas reduction fund')} target="_blank" href="https://www.epa.gov/greenhouse-gas-reduction-fund/about-greenhouse-gas-reduction-fund" data-click-listener="true" rel="noreferrer">Greenhouse Gas Reduction Fund</a> (GGRF), a program within the IRA, is a $27 billion program that aims to provide financial support and incentives for activities that lower energy costs, particularly in underserved communities. GGRF funds have yet to be deployed, but players in the affordable housing and energy sectors have an opportunity to prepare themselves to receive support at the local, state, and federal levels.
						</p>
					</div>
					<div className="flex-col-md-8 flex-col-sm-12 text-center pullquote-container ">
						<figure className="pullquote">
							<div className="bd-left">

								<blockquote cite="https://ternercenter.berkeley.edu/wp-content/uploads/2024/03/Terner-Housing-Climate-March-2024.pdf">
									<p>
										"Affordable housing has always worked under conditions of resource scarcity. The fact that there are now resources that we can tap into to make buildings more environmentally sustainable is amazing and potentially transformative."
									</p>

								</blockquote>
								<figcaption>&ndash; <cite>Carolina Reid, faculty research advisor at the Terner Center for Innovation</cite></figcaption>
							</div>

							<p className="cite-link">Read the Terner Center report here: <a onClick={()=>fireTag('A1','housing + climate policy: building equitable pathways to sustainability and affordability.')} target="_blank" href="https://ternercenter.berkeley.edu/wp-content/uploads/2024/03/Terner-Housing-Climate-March-2024.pdf">Housing + Climate Policy: Building Equitable Pathways to Sustainability and Affordability.</a></p>
						</figure>
					</div>
				</div>


				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
						<h2 className="subhead">
							Early engagement can create momentum
						</h2>
						<p>
							The Wells Fargo Foundation is providing grants to nonprofit affordable housing developers and other key organizations to help them prepare to pursue GGRF funding. Without funding or support, groups — particularly grassroots and community-based organizations with limited resources — may not be prepared to build a pipeline of eligible GGRF projects.
						</p>
						<p>
							In California’s Bay Area, the <a onClick={()=>fireTag('A1','chinatown community development center')} target="_blank" href="https://www.chinatowncdc.org/" data-click-listener="true" rel="noreferrer">Chinatown Community Development Center</a> (CCDC) has close to <a onClick={()=>fireTag('A1','40 properties')} target="_blank" href="https://www.chinatowncdc.org/our-housing/rental-assistance-demonstration-rad-program" data-click-listener="true" rel="noreferrer">40 properties</a> in San Francisco, providing affordable housing to more than 5,000 residents. The buildings offer public housing for seniors and people with disabilities.
						</p>
						<p>
							"We care a lot about sustainability because of its environmental, operating, and human impact in our community," said Malcolm Yeung, CCDC’s executive director. "Currently, without having clear and consistent funding, sustainability becomes an afterthought."
						</p>

						<p>Through the GGRF, eligible nonprofit entities will be able <a onClick={()=>fireTag('A1','to apply')} target="_blank" href="https://www.epa.gov/newsreleases/epa-announces-initial-program-design-greenhouse-gas-reduction-fund?force_isolation=true" data-click-listener="true" rel="noreferrer">to apply</a> for funding from financial intermediaries like green banks, community development financial institutions, or minority deposit institutions to support projects intended to cut pollution and lower energy burdens associated with housing. In some locations, organizations may be able to aggregate GGRF funding with state and local financial incentives and subsidies — like those coordinated with state energy offices and utilities — to further decrease the cost of clean energy installations like heat pumps or other energy-efficient improvements.
						</p>

						<p>A <a onClick={()=>fireTag('A1','report')} target="_blank" href="https://www.nrdc.org/bio/michele-knab-hasson/overcoming-decarbonization-barriers-angeless-affordable-housing" data-click-listener="true" rel="noreferrer">report</a> from the Natural Resources Defense Council finds unwieldy administrative processes create a significant barrier to assembling capital for all kinds of projects. To overcome these challenges, CCDC is using its grant to position potential projects for GGRF funding. An employee with technical knowledge is assessing potential projects for consideration of GGRF funding by identifying the buildings best suited for sustainability upgrades.
						</p>


						<p>"Without having a dedicated staff member, there’s no way we could have done it," Yeung said.</p>

						<h2 className="subhead">Building audits can identify valuable opportunities</h2>

						<p><a onClick={()=>fireTag('A1','eden housing')} target="_blank" href="https://edenhousing.org/about-us/our-impact/green-initiatives/" data-click-listener="true" rel="noreferrer">Eden Housing</a>, another affordable housing nonprofit, is focused on improving building performance to reduce emissions and improve operating costs to reduce tenant electric bills.</p>

						<p>Tom White, associate director for building performance and sustainability, routinely explores opportunities to improve building efficiency. White and other housing managers first identify the most effective and worthwhile areas for improvement before pursuing funding.</p>

						<p>"We are performing greenhouse gas assessments, also called decarbonization audits, where we can figure if this building is generating a lot more carbon emissions than our standard new construction," White said. "There is a great opportunity to combine these new financing sources to make a big dent in our carbon footprint."</p>

						<p>Yeung adds, "The folks who are prepared to access this money because they’ve done the pre-work to get their portfolios ready, those are the ones that are going to get funding."</p>

						<p>Wells Fargo’s collaboration with CCDC and Eden Housing demonstrates the value in planning, which can help shift sustainability from an afterthought to a driving force for economic and environmental opportunities. Upfront strategic funding, knowledgeable staff, and portfolio preparation are crucial for success.</p>

					</div>
				</div>

				{/*<KonamiElement className="grid"/>*/}

			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
			{/* Adobe retargeting tag */}
			{
				/*
					REMOVE TAG
					<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}
		</>
	);
};

export default withRouter(Pipeline);
